import { render } from "./GuestNavbar.vue?vue&type=template&id=c9f31438"
import script from "./GuestNavbar.vue?vue&type=script&lang=js"
export * from "./GuestNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/TheIdFactory/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__